import React from 'react';
import { 
  SidebarContainer, 
  Icon, 
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarRoute
} from './SidebarElements';

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="about" onClick={toggle}>Über uns</SidebarLink>
          <SidebarLink to="discover" onClick={toggle}>Lösungen</SidebarLink>
          <SidebarLink to="services" onClick={toggle}>Leistungen</SidebarLink>
          <SidebarLink to="servicepackages" onClick={toggle}>Servicepakete</SidebarLink>
          <SidebarLink to="contact" onClick={toggle}>Kontakt</SidebarLink>
          <SidebarLink to="testimonials" onClick={toggle}>Kundenstimmen</SidebarLink>
          <a 
            href="/fernwartung" 
            onClick={toggle}
            style={{ color: '#fff', textDecoration: 'none', fontSize: '1.5rem', display: 'block', textAlign: 'center' }}
          >
            Fernwartung
          </a>
        </SidebarMenu>

        {/* CTA Button unten */}
        <SideBtnWrap>
        <SidebarRoute
            to="contact"
            smooth={true}
            duration={500}
            offset={-80}
            onClick={toggle}   // Sidebar nach Klick schließen
        >
            Gratis IT-Check
        </SidebarRoute>
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
